import React from "react";
import cx from 'classnames';
import chatIcon from "../../images/icons/chat-icon.svg";
import {getUserData} from '../../services/API';

export default class ChatSupport extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      chatAgentOnline: false
    }

    this.openChat = this.openChat.bind(this);
    this.checkChatAgentStatus = this.checkChatAgentStatus.bind(this);
    this.loadEmbeddedChat = this.loadEmbeddedChat.bind(this);

  }

  componentDidMount(){
    this.loadEmbeddedChat();
    const intId = setInterval(e => {
      const chatLoaded = this.checkChatAgentStatus();
      if(chatLoaded) clearInterval(intId);
    }, 1000);
  }

  openChat() {
    const button = document.querySelector("#helpButtonSpan > span.message");
    button.click();
  }

  checkChatAgentStatus(){
    const helpButtonMessage = document.querySelector("#helpButtonSpan > span.message");
    if(!helpButtonMessage) return false;
    const chatAgentStatus = helpButtonMessage.innerText;
    if(chatAgentStatus === "Chat with an Expert"){
      this.setState({chatAgentOnline: true})
    }
    return true;
  }

  loadEmbeddedChat() {
    const { firstName, lastName, district, schools } = getUserData();
    const salesForceDeploymentScript = document.createElement('script');
      salesForceDeploymentScript.defer = true;
      salesForceDeploymentScript.type = 'text/javascript';
      salesForceDeploymentScript.src = 'https://service.force.com/embeddedservice/5.0/esw.min.js';
      salesForceDeploymentScript.onload = () => {
    var initESW = (gslbBaseURL) => {
      embedded_svc.settings.displayHelpButton = true; 
      embedded_svc.settings.defaultMinimizedText = '';
      embedded_svc.settings.offlineSupportMinimizedText = "Offline - send us a message";
  
      embedded_svc.settings.enabledFeatures = ['LiveAgent'];
      embedded_svc.settings.entryFeature = 'LiveAgent';
  
      embedded_svc.settings.prepopulatedPrechatFields = {
          FirstName: firstName,
          LastName: lastName,
          District_School__c: `${district.label} - ${schools[0].label}`,
      };
  
      embedded_svc.addEventHandler("onAvailability", ({isAgentAvailable}) => {
        if(isAgentAvailable){
          this.setState({chatAgentOnline: true})
        } else {
          this.setState({chatAgentOnline: false})
        }
      });
  
      embedded_svc.init(
        'https://amiralearning2022.my.salesforce.com',
        'https://support.amiralearning.com/',
        gslbBaseURL,
        '00D5f000006QNQU',
        'Amira_learning',
        {
          baseLiveAgentContentURL: 'https://c.la4-c1-ia5.salesforceliveagent.com/content',
          deploymentId: '5725f000000MI1e',
          buttonId: '5735f000000MIvk',
          baseLiveAgentURL: 'https://d.la4-c1-ia5.salesforceliveagent.com/chat',
          eswLiveAgentDevName: 'EmbeddedServiceLiveAgent_Parent04I5f000000H9kGEAS_1818c259497',
          isOfflineSupportEnabled: true
        }
      );
    };
  
    if (!window.embedded_svc) {
      var s = document.createElement('script');
      s.setAttribute('src', 'https://amiralearning2022.my.salesforce.com/embeddedservice/5.0/esw.min.js');
      s.onload = function() {
        initESW(null);
        let helpText = document.querySelector('#helpButtonSpan');
      };
      document.body.appendChild(s);
    } else {
      initESW('https://service.force.com');
      let helpText = document.querySelector('#helpButtonSpan');
    }
  }
  document.body.appendChild(salesForceDeploymentScript);
  }

  render(){
    const chatSupportClasses = cx({
      'chatSupport': true,
      'embeddedServiceHelpButton': true,
    });

    return (<></>
      // TODO: ADD BACK CHAT MODAL EVENTUALLY
      // <div id="chatModalContainer">
      //   <div className={chatSupportClasses} onClick={this.openChat}>
      //     <div id="liveagent_button_online_5735f000000MIvk" className="launchChatButton" role="button">
      //       <img className="chatIcon" src={chatIcon} alt=""/>
      //     </div>
      //     {this.state.chatAgentOnline && <div id="chat-label">Get Help NOW</div>}
      //     {!this.state.chatAgentOnline && <div id="chat-label"><div>Offline</div> Send us a message</div>}
      //   </div>
      // </div>
    );
  }
}

